module.exports = __webpack_public_path__ + "img/cat-head.e26803ba.svg";